import { render, staticRenderFns } from "./bck_2026-06-23-FrontWorkerIdentificationDocument.vue?vue&type=template&id=31d68ba6&scoped=true"
import script from "./bck_2026-06-23-FrontWorkerIdentificationDocument.vue?vue&type=script&lang=js"
export * from "./bck_2026-06-23-FrontWorkerIdentificationDocument.vue?vue&type=script&lang=js"
import style0 from "./bck_2026-06-23-FrontWorkerIdentificationDocument.vue?vue&type=style&index=0&id=31d68ba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d68ba6",
  null
  
)

export default component.exports